import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

import styles from './Title.module.scss';

interface ITitleProps {
  type: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
}

const Title = ({ type, children, className }: PropsWithChildren<ITitleProps>) => {
  const titleClassName = clsx(styles[type], className);

  const renderElementByType = () => {
    switch (type) {
      case 'h2':
        return <h2 className={titleClassName}>{children}</h2>;
      case 'h3':
        return <h3 className={titleClassName}>{children}</h3>;
      case 'h4':
        return <h4 className={titleClassName}>{children}</h4>;
      case 'h5':
        return <h5 className={titleClassName}>{children}</h5>;
      case 'h6':
        return <h6 className={titleClassName}>{children}</h6>;
      default:
        return <h3 className={titleClassName}>{children}</h3>;
    }
  };

  return renderElementByType();
};

export default Title;
